export var defaultAllowedOriginsSuffix = ['//localhost', '//localhost:3000', '//localhost:8080', '//localhost:8081', '//ad.doubleclick.net', '//s0.2mdn.net', '//s1.2mdn.net', '//tpc.googlesyndication.com', 'kbb.com', 'na.autotrader.int', 'safeframe.googlesyndication.com'];
export default (function (origin) {
  var allowedOriginsSuffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultAllowedOriginsSuffix;
  return allowedOriginsSuffix.filter(function (suffx) {
    return origin.toLowerCase().endsWith(suffx);
  }).length > 0;
});